import { render, staticRenderFns } from "./Index_copy.vue?vue&type=template&id=162e7b33&scoped=true"
import script from "./Index_copy.vue?vue&type=script&lang=js"
export * from "./Index_copy.vue?vue&type=script&lang=js"
import style0 from "./Index_copy.vue?vue&type=style&index=0&id=162e7b33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e7b33",
  null
  
)

export default component.exports